import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'lin-cell-text',
  template: '<p class="text-truncate"><ng-content></ng-content></p>',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TextCellComponent {}
